(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const instances = new Map();
  const modalSelector = 'dialog[open], product-modal[open], cart-drawer.active, cart-notification.active, [aria-modal="true"], .pplr-popup';
  const visible = (element) => {
    if (!element || !element.isConnected || element.hidden) return false;
    if (element.checkVisibility && !element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0;
  };
  const inViewport = (element) => {
    if (!visible(element)) return false;
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  function init(section) {
    if (instances.has(section)) return;
    const template = section.querySelector('[data-gf-sticky-template]');
    if (!template) return;
    const button = template.content.firstElementChild.cloneNode(true);
    document.body.append(button);
    const abort = new AbortController();
    const options = { signal: abort.signal, passive: true };
    const mobile = matchMedia('(max-width: 749px)');
    let frame = 0;
    let lockUntil = 0;
    let unlockTimer = 0;
    const controls = () => {
      const form = section.querySelector('product-form');
      const submit = form?.querySelector('.product-form__submit');
      const personalizer = section.querySelector('.product-personalizer .ptc_button');
      const wait = section.querySelector('.gf-personalization-wait');
      return { form, submit, personalizer, wait };
    };
    const obstructed = () => {
      const focus = document.activeElement;
      const editing = focus?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]');
      const keyboard = window.visualViewport && window.visualViewport.height < innerHeight - 120;
      const locked = /(?:^|\s)(?:pplr_fixed|pplr_fixed_cropper|overflow-hidden)(?:\s|$)/.test(document.body.className);
      return editing || keyboard || locked || Array.from(document.querySelectorAll(modalSelector)).some(inViewport);
    };
    const update = () => {
      frame = 0;
      const { form, submit, personalizer, wait } = controls();
      const actions = [submit, personalizer, wait].filter(visible);
      const passed = actions.length > 0 && actions.every((action) => action.getBoundingClientRect().bottom <= 0);
      const busy = performance.now() < lockUntil || submit?.classList.contains('loading') || submit?.getAttribute('aria-disabled') === 'true';
      const unavailable = !form || !submit || submit.disabled;
      const hidden = !mobile.matches || !section.isConnected || !passed || unavailable || obstructed();
      if (button.hidden !== Boolean(hidden)) button.hidden = Boolean(hidden);
      if (button.disabled !== Boolean(busy)) button.disabled = Boolean(busy);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const reveal = (element) => {
      element.scrollIntoView({ block: 'center', behavior: 'instant' });
      element.focus({ preventScroll: true });
    };
    button.addEventListener('click', () => {
      update();
      if (button.hidden || button.disabled) return;
      const { form, submit, personalizer } = controls();
      if (!form || !submit || submit.disabled) return;
      lockUntil = performance.now() + 1000;
      button.disabled = true;
      clearTimeout(unlockTimer);
      unlockTimer = setTimeout(schedule, 1050);
      if (!visible(submit) || submit.classList.contains('pplr_hide')) {
        if (visible(personalizer)) { reveal(personalizer); personalizer.click(); }
        schedule();
        return;
      }
      const nativeForm = submit.form || form.querySelector('form');
      const invalid = Array.from(nativeForm?.elements || []).find((field) => field.willValidate && !field.validity.valid);
      if (invalid) {
        if (visible(invalid)) { reveal(invalid); invalid.reportValidity(); }
        else if (visible(personalizer)) { reveal(personalizer); personalizer.click(); }
        schedule();
        return;
      }
      submit.click();
      schedule();
    }, { signal: abort.signal });
    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', schedule, options);
    window.visualViewport?.addEventListener('resize', schedule, options);
    document.addEventListener('focusin', schedule, options);
    document.addEventListener('focusout', schedule, options);
    document.addEventListener('toggle', schedule, { ...options, capture: true });
    document.body.addEventListener('modalClosed', schedule, options);
    mobile.addEventListener('change', schedule, options);
    const observer = new MutationObserver((records) => {
      if (records.some((record) => record.target !== button && !button.contains(record.target))) schedule();
    });
    observer.observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled'] });
    const overlays = new MutationObserver((records) => {
      if (records.some((record) => record.target === document.body || record.target.matches?.('dialog, product-modal, cart-drawer, cart-notification, [role="dialog"], .pplr-popup'))) schedule();
    });
    overlays.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style'] });
    const resize = new ResizeObserver(schedule);
    resize.observe(section);
    instances.set(section, () => {
      abort.abort(); observer.disconnect(); overlays.disconnect(); resize.disconnect();
      cancelAnimationFrame(frame); clearTimeout(unlockTimer); button.remove(); instances.delete(section);
    });
    schedule();
  }
  const scan = (root) => {
    if (root.matches?.('product-info.gf-mobile-product')) init(root);
    root.querySelectorAll('product-info.gf-mobile-product').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, dispose] of instances) if (event.target === section || event.target.contains(section)) dispose();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
